import React, { useEffect, useState, useCallback, useRef, useMemo } from 'react'
import { Link } from 'react-router-dom'
import { _Api } from '../../api/_call'
import TableColumnModal from '../../common/modules/tableColumn'
import { VoucherList } from '../../common/graphql/commonlayouts'
import Advancedfiltermodel from '../../common/modules/advanced-filter-model'
import { formatDate } from '../../common/helpers/formatDate'
import { createtransferinventoryheadcheck } from '../../common/Tablehead'
import { error } from '../../common/helpers/toastify'
import { toUnformatPrice, toFormatPrice } from '../../common/helpers/function'
import { useTranslation } from 'react-i18next'
import { Pagination } from '../../common/Pagination'
import Filtermodal from '../../common/modules/Filtermodal'
import Select from "react-select"
import TableLoader from '../../../admin/common/TableLoader'
import Stockidmodal from "../../common/modules/Stockidmodal";
import { canSelectFreeStockRows, canTransferRow, isFreeStockRow } from '../../common/helpers/canSelectAllRows'

// Column order mirrors createtransferinventoryhead / createtransferinventoryheadcheck.
const SORT_KEYS = [
  null, null, null, "sku", "item", "collection", "metal", "stone", "size",
  "stock_id", null, "qty", "price", "aging", "location", "status",
  "pos_order", "customer", "delivery_date", "due_days", null, null,
];
const SORT_ACCESSORS = {
  sku: (r) => r?.SKU,
  item: (r) => r?.item_name,
  collection: (r) => r?.collection_name,
  metal: (r) => r?.metal_name,
  stone: (r) => r?.stone_name,
  size: (r) => r?.size_name,
  stock_id: (r) => r?.stock_id,
  qty: (r) => Number(r?.po_QTY) || 0,
  price: (r) => Number(toUnformatPrice(r?.price)) || 0,
  aging: (r) => Number(r?.aging) || 0,
  location: (r) => r?.location_name,
  status: (r) => r?.status_type,
  pos_order: (r) => r?.POS_Order,
  customer: (r) => r?.customer_name,
  delivery_date: (r) => r?.delivery_date,
  due_days: (r) => Number(r?.due_days) || 0,
};

const CreateTransferInventory = (props) => {
  const { t } = useTranslation()

  const dataFetched = useRef()

  const base_assets = process.env.REACT_APP_BASE_ASSETS_URL
  const [datalodaer, setDatsLodaer] = useState(false)
  const [limit, setLimit] = useState(100)
  const [filtername, setFiltername] = useState('')
  const [transferinventorylist, setTransferinventorylist] = useState([])
  const [createlist, setCreatelist] = useState([])
  const [selectedlocation, setSelectedlocation] = useState()
  const [selectedwarehouse, setSelectedwarehouse] = useState('')
  const [SelectAllStatus, setSelectAllStatus] = useState()
  const selectAllActiveRef = useRef(false)
  // Latest selection lock for the list fetch, which is a memoised callback.
  const rowLockRef = useRef({})
  rowLockRef.current = { locationId: selectedlocation, warehouseId: selectedwarehouse }
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" })
  const base_url_assets = process.env.REACT_APP_BASE_ASSETS_URL
  const [commanSelected_vouc, setcommanSelected_vouc] = useState(null)
  const [rowlength, setRowlength] = useState(0);
  const [payload, setPayload] = useState()
  const filterbyname = (search) => {
    Gettransferinventory(1, limit, payload, search)
  }
  const getlimit = (limit) => {
    setLimit(limit)
    Gettransferinventory(1, limit, payload, payload?.search)
  }
  const handlePaginations = (current) => {
    Gettransferinventory(current, "", payload, payload?.search, payload?.stock_ids)
  }
  const [state, setstate] = useState({
    totalPages: 20,
    currentPage: 1,
  })

  const { totalPages, currentPage } = state

  const Gettransferinventory = useCallback(
    async (current, firstlimit, filter, search, stock_id) => {
      setDatsLodaer(true)
      try {
        const tablelimit = firstlimit ? firstlimit : limit
        const skipNumber =
          current && tablelimit !== "ALL" ? (current - 1) * tablelimit : 0
        const postdata = {
          item: filter?.item ? filter?.item : [],
          collection: filter?.collection ? filter?.collection : [],
          metal: filter?.metal ? filter?.metal : [],
          size: filter?.size ? filter?.size : [],
          stone: filter?.stone ? filter?.stone : [],
          productStatus: filter?.status ? filter?.status : filter?.productStatus ? filter?.productStatus : [],
          location: filter?.location ? filter?.location : [],
          price: filter?.price ? filter?.price : [],
          search: search ? search : "",
          "limit": tablelimit,
          skip: skipNumber,
          stock_ids: stock_id?.length ? stock_id : []
        }
        let restransferinventory = await _Api(
          postdata,
          `api/v1/Inventory/stocktransfer/getInventoryList`,
        )
        if (restransferinventory.code === 200) {
          setPayload(postdata)
          setstate((prev) => ({
            ...prev,
            totalPages:
              tablelimit === "ALL"
                ? 1
                : Math.ceil(restransferinventory.count / tablelimit),
            currentPage: current ? current : 1,
          }))
          // New list: a select-all made on the old rows no longer applies.
          if (selectAllActiveRef.current) {
            selectAllActiveRef.current = false
            setSelectAllStatus(false)
            setCreatelist([])
            setSelectedlocation('')
            setSelectedwarehouse('')
            rowLockRef.current = {}
          }
          // Rows ticked on another page stay selected, so keep this page locked to their location.
          const { locationId, warehouseId } = rowLockRef.current
          const lockWarehouse = warehouseId && warehouseId !== 'null' ? warehouseId : ''
          let updatedata = restransferinventory.data.map(item => ({
            ...item,
            rowclass:
              locationId &&
              (item?.location_id !== locationId ||
                (lockWarehouse && item?.warehouse_id && item?.warehouse_id !== lockWarehouse))
                ? 'row-inactive'
                : '',
          }));
          setTransferinventorylist(updatedata)
          setDatsLodaer(false)
          setRowlength(skipNumber);
          dataFetched.current = true

        } else {
          setDatsLodaer(false)
        }
      } catch (err) {
        console.log(err, 'err')
        setDatsLodaer(false)
      }
    },
    // eslint-disable-next-line
    [filtername, limit, state],
  )
  const selectOptions = [
    { label: 100, value: 100 },
    { label: 200, value: 200 },
    { label: 300, value: 300 }
  ]
  const submitlist = (event) => {
    const array = [...createlist]
    const mainarray = [...transferinventorylist]
    if (event.target.checked) {
      const currentid = mainarray.filter((all) => {
        return all.id === event.target.value
      })

      if (!selectedwarehouse) {
        setSelectedlocation(currentid[0]?.location_id)
        setSelectedwarehouse(
          currentid[0]?.warehouse_id ? currentid[0]?.warehouse_id : 'null',
        )
      }

      mainarray.forEach((result, key) => {
        if (
          result?.location_id !==
          (selectedlocation ? selectedlocation : currentid[0]?.location_id)
        ) {
          mainarray[key] = {
            ...mainarray[key],
            rowclass: 'row-inactive',
          }
        } else {
          if (currentid[0]?.warehouse_id === '') {
            if (selectedwarehouse === '' || selectedwarehouse === 'null') {
              mainarray[key] = {
                ...mainarray[key],
                rowclass: '',
              }
            } else {
              if (
                result?.warehouse_id !==
                (selectedwarehouse
                  ? selectedwarehouse
                  : currentid[0]?.warehouse_id
                    ? currentid[0]?.warehouse_id
                    : 'null')
              ) {
                if (
                  result?.warehouse_id === '' ||
                  (selectedwarehouse
                    ? selectedwarehouse
                    : currentid[0]?.warehouse_id
                      ? currentid[0]?.warehouse_id
                      : 'null') === ''
                ) {
                  mainarray[key] = {
                    ...mainarray[key],
                    rowclass: '',
                  }
                } else {
                  mainarray[key] = {
                    ...mainarray[key],
                    rowclass: 'row-inactive',
                  }
                }
              } else {
                mainarray[key] = {
                  ...mainarray[key],
                  rowclass: '',
                }
              }
            }
          } else {
            if (selectedwarehouse === 'null') {
              setSelectedwarehouse(currentid[0]?.warehouse_id)
              if (result?.warehouse_id !== currentid[0]?.warehouse_id) {
                if (result?.warehouse_id === '') {
                  mainarray[key] = {
                    ...mainarray[key],
                    rowclass: '',
                  }
                } else {
                  mainarray[key] = {
                    ...mainarray[key],
                    rowclass: 'row-inactive',
                  }
                }
              } else {
                mainarray[key] = {
                  ...mainarray[key],
                  rowclass: '',
                }
              }
            } else {
              if (
                result?.warehouse_id !==
                (selectedwarehouse
                  ? selectedwarehouse
                  : currentid[0]?.warehouse_id
                    ? currentid[0]?.warehouse_id
                    : 'null')
              ) {
                if (
                  result?.warehouse_id === '' ||
                  (selectedwarehouse
                    ? selectedwarehouse
                    : currentid[0]?.warehouse_id
                      ? currentid[0]?.warehouse_id
                      : 'null') === ''
                ) {
                  mainarray[key] = {
                    ...mainarray[key],
                    rowclass: '',
                  }
                } else {
                  mainarray[key] = {
                    ...mainarray[key],
                    rowclass: 'row-inactive',
                  }
                }
              } else {
                mainarray[key] = {
                  ...mainarray[key],
                  rowclass: '',
                }
              }
            }
          }
        }
      })
      setTransferinventorylist(mainarray)
      array.push(event.target.value)
      setCreatelist(array)
    } else {
      selectAllActiveRef.current = false
      setSelectAllStatus(false)
      if (array.length === 1) {
        setCreatelist((current) =>
          current.filter((item) => item !== event.target.value),
        )
        mainarray.forEach((result, key) => {
          mainarray[key] = {
            ...mainarray[key],
            rowclass: '',
          }
          setTransferinventorylist(mainarray)
        })
        setSelectedlocation('')
        setSelectedwarehouse('')
      } else {
        setCreatelist((current) =>
          current.filter((item) => item !== event.target.value),
        )
      }
    }
  }
  useEffect(() => {
    if (dataFetched.current) return
    dataFetched.current = true
    Gettransferinventory()
  }, [Gettransferinventory])

  const selectedproduct = (event) => {
    if (event.target.checked) {
      const mainselected = [...createlist, event.target.value]
      setCreatelist(mainselected)
    } else {
      const result = createlist.filter((element) => {
        return element !== event.target.value
      })
      setCreatelist(result)
    }
  }
  const canSelectAll = canSelectFreeStockRows(transferinventorylist)
  const handleSelectAll = (isChecked) => {
    const pageIds = transferinventorylist.map((row) => row?.id)
    selectAllActiveRef.current = isChecked
    setSelectAllStatus(isChecked)
    if (isChecked) {
      const freeRows = transferinventorylist.filter(isFreeStockRow)
      setCreatelist((current) => [...new Set([...current, ...freeRows.map((row) => row?.id)])])
      setSelectedlocation(freeRows[0]?.location_id)
      setSelectedwarehouse(
        freeRows.find((row) => row?.warehouse_id)?.warehouse_id || 'null',
      )
    } else {
      const remaining = createlist.filter((id) => !pageIds.includes(id))
      setCreatelist(remaining)
      if (!remaining.length) {
        setSelectedlocation('')
        setSelectedwarehouse('')
        setTransferinventorylist((prev) => prev.map((row) => ({ ...row, rowclass: '' })))
      }
    }
  }
  // Custom client-side sorting (replaces jQuery DataTables sorting).
  const handleSort = (key) => {
    setSortConfig((prev) =>
      prev.key === key
        ? { key, direction: prev.direction === "asc" ? "desc" : "asc" }
        : { key, direction: "asc" }
    )
  }
  const sortedList = useMemo(() => {
    const list = Array.isArray(transferinventorylist) ? transferinventorylist : []
    const accessor = SORT_ACCESSORS[sortConfig.key]
    if (!accessor) return list
    const sorted = [...list].sort((a, b) => {
      const av = accessor(a)
      const bv = accessor(b)
      if (av === undefined || av === null || av === "") return 1
      if (bv === undefined || bv === null || bv === "") return -1
      if (typeof av === "number" && typeof bv === "number") return av - bv
      return String(av).localeCompare(String(bv), undefined, { numeric: true })
    })
    return sortConfig.direction === "asc" ? sorted : sorted.reverse()
  }, [transferinventorylist, sortConfig])
  const tablehead = createtransferinventoryheadcheck
  const countstockid = (stiockidindex) => {
    if (stiockidindex) {
      const numbersArray = stiockidindex.split(/\D+/)
      if (numbersArray?.length) {
        Gettransferinventory(1, 'ALL', payload, filtername, numbersArray)
      } else {
        error("Somthing Went Wrong");
      }
    } else {
      Gettransferinventory(1, limit, payload, filtername, [])
    }
  };
  return (
    <React.Fragment>
      <div className="main-body">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">

              <div className="top-heading-area">
                <div className="top-heading-area-left">
                  <Link
                    to="/app/inventory/stock_transfer"
                    className="page-back-btn"
                  >
                    <img
                      src={base_url_assets + 'images/icons/arrow-left.png'}
                      alt=""
                    />
                  </Link>
                  <img
                    src={base_url_assets + 'images/icons/home-icon.png'}
                    alt=""
                  />
                  <VoucherList
                    setcommanSelected_vouc={setcommanSelected_vouc}
                    group={'Stock_Transfer'}
                  ></VoucherList>
                </div>
                <h1 className="main-heading text-center">
                  {t('Create transfer')}
                </h1>
              </div>
              <div className="main-body-top-tab-bar create-purchase-top-bar">
                <div className="main-body-top-tab-bar-left-col nav nav-pills">
                  <Link className="main-body-top-tab-bar-left-col-a nav-link active table-refresh">
                    <span className="main-body-top-tab-bar-left-col-a-text">
                      <img
                        src={
                          base_url_assets + 'images/icons/inventory-icon.png'
                        }
                        alt=""
                      />
                      {t('Inventory List')}
                    </span>
                  </Link>
                </div>
              </div>
              <div className="main-body-top-status-bar justify-content-between">
                <div className='d-flex'>
                  <Select
                    className="limit-select short mx-3 z-10"
                    options={selectOptions}
                    value={{ label: limit, value: limit }}
                    onChange={(e) => {
                      setLimit(e.value)
                      getlimit(e.value)
                    }}
                  />
                  <div className="main-body-top-status-bar-filter">
                    <button
                      className="main-body-top-status-bar-filter-icon"
                      data-bs-toggle="modal"
                      data-bs-target="#filterinventory"
                    >
                      <img
                        className="d-block"
                        src={base_url_assets + '/images/icons/search-outline.png'}
                        alt=""
                      />
                    </button>
                    <input
                      type="text"
                      value={filtername}
                      className="main-body-top-status-bar-filter-input"
                      placeholder={t('StockID/SKU')}
                      onKeyPress={(e) => e.key === 'Enter' && filterbyname(e.target.value)}
                      onChange={(e) => setFiltername(e.target.value)}
                    />
                    {filtername ? (
                      <img
                        className="main-body-top-status-bar-filter-clear"
                        src={base_assets + 'images/icons/False.png'}
                        onClick={(e) => { setFiltername(''); filterbyname(e.target.value) }}
                        alt=""
                      />
                    ) : (
                      ''
                    )}
                    <button
                      onClick={() => filterbyname(filtername)}
                      className="main-body-top-status-bar-filter-search"
                    >
                      <i className="fa fa-search" aria-hidden="true" />
                    </button>
                  </div>
                </div>
                <div className='d-flex gap-3'>
                  <button className="print-export-dropdown-selected-icon ms-auto"
                    data-bs-toggle="modal"
                    data-bs-target="#Stockidmodal">
                    <img
                      className={"deletebtn d-block"}
                      src={base_assets + "images/icons/clone.svg"}
                      alt=""
                    />
                  </button>
                  {createlist?.length ? (
                    <Link
                      className="ms-auto com-btn"
                      to="/app/inventory/createTransfer"
                      state={{
                        createlist: createlist,
                        Voucher_id: commanSelected_vouc,
                        hidelocationid: selectedlocation,
                        showwarehouseid: selectedwarehouse,
                        myinventory: false
                      }}
                    >
                      {t('Submit')}
                    </Link>
                  ) : (
                    <button
                      className="ms-auto com-btn"
                      onClick={() => error(t('No item Selected!!'))}
                    >
                      {t('Submit')}
                    </button>
                  )}
                </div>
              </div>
              <div className="common-sub-table-wrap add-row">
                <div className="main-body-main-table-wrap">
                  <>
                    <table
                      id="tbl_createTransfer_list"
                      className="common-table first-row-gray w-100"

                    >
                      <thead>
                        <tr>
                          {tablehead?.map((col, index) => {
                            if (!col?.status) return null
                            if (col.name === "check_box") {
                              return (
                                <th key={index}>
                                  <div
                                    className={canSelectAll ? "com-check" : "com-check checkbox-disabled"}
                                    title={canSelectAll ? "" : t("Select all needs rows from one location")}
                                  >
                                    <input
                                      id="th_comman_checkbox"
                                      checked={Boolean(SelectAllStatus)}
                                      disabled={!canSelectAll}
                                      onChange={(e) => handleSelectAll(e.target.checked)}
                                      className={col.class}
                                      data-select={col.class}
                                      type="checkbox"
                                    />
                                    <label
                                      htmlFor="th_comman_checkbox"
                                      className="com-check-label"
                                    />
                                  </div>
                                </th>
                              )
                            }
                            const sortKey = SORT_KEYS[index]
                            const active = sortConfig.key === sortKey
                            return (
                              <th
                                key={index}
                                className={col.class}
                                onClick={sortKey ? () => handleSort(sortKey) : undefined}
                                style={sortKey ? { cursor: "pointer" } : undefined}
                              >
                                {t(col.lable)}
                                {sortKey ? (
                                  <div className="up-down-arrow-btn">
                                    <img
                                      className={
                                        "up-down-arrow-img up-down-arrow-img-forward" +
                                        (active && sortConfig.direction === "desc" ? "" : " active")
                                      }
                                      src={base_url_assets + "images/icons/up-down-arrow.png"}
                                      alt=""
                                    />
                                    <img
                                      className={
                                        "up-down-arrow-img up-down-arrow-img-reverse" +
                                        (active && sortConfig.direction === "desc" ? " active" : "")
                                      }
                                      src={base_url_assets + "images/icons/up-down-arrow-reverse.png"}
                                      alt=""
                                    />
                                  </div>
                                ) : null}
                              </th>
                            )
                          })}
                        </tr>
                      </thead>
                      <tbody id="allsamedata">
                        {sortedList
                          ? sortedList.map((result, key) => {
                            const isSelected = createlist.some(
                              (id) => String(id) === String(result?.id)
                            )
                            return (
                              <tr
                                id={`common-main-table-wrap-${result?.id}`}
                                className={
                                  result?.rowclass ? result?.rowclass : ''
                                }
                                key={result?.id || key}
                              >
                                <td >
                                  <div className={
                                    canTransferRow(result)
                                      ? 'com-check'
                                      : 'com-check checkbox-disabled'
                                  }>
                                    <input
                                      id={result?.id}
                                      data-id={result?.id}
                                      value={result?.id}
                                      location_id={result?.location_id}
                                      warehouse_id={result?.warehouse_id}
                                      className={"createtransferinventory createtransferinventoryhead"}
                                      onChange={selectedproduct}
                                      onClick={submitlist}
                                      checked={isSelected}
                                      disabled={!canTransferRow(result)}
                                      type="checkbox"
                                    />
                                    <label htmlFor={result?.id} className="com-check-label" />
                                  </div>
                                </td>
                                <td>{key + rowlength + 1}</td>
                                <td className="table-pro-img">
                                  <img
                                    src={
                                      result?.main_image
                                        ? result?.main_image
                                        : base_url_assets +
                                        'images/icon/camera_profile.png'
                                    }
                                    alt=""
                                  />
                                </td>
                                <td className="po-no">
                                  {result?.SKU ? result?.SKU : ''}
                                </td>
                                <td>
                                  {result?.item_name ? result?.item_name : ''}
                                </td>
                                <td>
                                  {result?.collection_name
                                    ? result?.collection_name
                                    : ''}
                                </td>
                                <td>
                                  {result?.metal_name ? result?.metal_name : ''}
                                </td>
                                <td>
                                  {result?.stone_name ? result?.stone_name : ''}
                                </td>
                                <td>
                                  {result?.size_name ? result?.size_name : ''}
                                </td>
                                {result.status_stock_id === 'stock' ? (
                                  <td className="light-blue-text" data-order={result?.stock_id ? result?.stock_id : ''}>
                                    <div className="tooltip-area-up">
                                      {result?.stock_id ? result?.stock_id : ''}
                                      <span className="tooltip-area-up-text">
                                        {formatDate(result?.delivery_date)}
                                      </span>
                                    </div>
                                  </td>
                                ) : result.status_stock_id === 'transit' ? (
                                  <td className="status-green-text" data-order={result?.stock_id ? result?.stock_id : ''}>
                                    <div className="tooltip-area-up">
                                      {result?.stock_id ? result?.stock_id : ''}
                                      <span className="tooltip-area-up-text">
                                        {formatDate(result?.delivery_date)}
                                      </span>
                                    </div>
                                  </td>
                                ) : result.status_stock_id === 'warehouse' ? (
                                  <td className="status-gray-text" data-order={result?.stock_id ? result?.stock_id : ''}>
                                    <div className="tooltip-area-up">
                                      {result?.stock_id ? result?.stock_id : ''}
                                      <span className="tooltip-area-up-text">
                                        {formatDate(result?.delivery_date)}
                                      </span>
                                    </div>
                                  </td>
                                ) : result.status_stock_id === 'reserve' ? (
                                  <td className="yellow-text" data-order={result?.stock_id ? result?.stock_id : ''}>
                                    <div className="tooltip-area-up">
                                      {result?.stock_id ? result?.stock_id : ''}
                                      <span className="tooltip-area-up-text">
                                        {result?.customer_name}{' '}
                                        {result?.customer_name ? <br /> : ''}{' '}
                                        {formatDate(result?.delivery_date)}
                                      </span>
                                    </div>
                                  </td>
                                ) : result.status_stock_id ===
                                  'repair_order' ? (
                                  <td className="purple-text" data-order={result?.stock_id ? result?.stock_id : ''}>
                                    <div className="tooltip-area-up">
                                      {result?.stock_id ? result?.stock_id : ''}
                                      <span className="tooltip-area-up-text">
                                        {result?.customer_name}{' '}
                                        {result?.customer_name ? <br /> : ''}{' '}
                                        {result?.POS_Order} <br />{' '}
                                        {formatDate(result?.delivery_date)}
                                      </span>
                                    </div>
                                  </td>
                                ) : result.status_stock_id ===
                                  'custom_order' ? (
                                  <td className="danger-text" data-order={result?.stock_id ? result?.stock_id : ''}>
                                    <div className="tooltip-area-up">
                                      {result?.stock_id ? result?.stock_id : ''}
                                      <span className="tooltip-area-up-text">
                                        {result?.customer_name}{' '}
                                        {result?.customer_name ? <br /> : ''}{' '}
                                        {result?.POS_Order} <br />{' '}
                                        {formatDate(result?.delivery_date)}
                                      </span>
                                    </div>
                                  </td>
                                ) : (
                                  ''
                                )}
                                <td className="sku-col table_btn_expand_col">
                                  <div className="td-icons-wrap">
                                    {result?.allocatable ? (
                                      <div className="td-icons-wrap-link">
                                        <img
                                          className="img"
                                          src={
                                            base_url_assets +
                                            'images/icons/link-icon.svg'
                                          }
                                          alt=""
                                        />
                                      </div>
                                    ) : (
                                      ''
                                    )}
                                  </div>
                                  <div className="td-icons-wrap-user">
                                    <div
                                      className="tooltip-area-up"
                                    >
                                      {result?.pos_Qty !== 0 ? (
                                        <div className="td-icons-wrap-user">
                                          <img
                                            className="img"
                                            src={
                                              base_url_assets +
                                              'images/icons/user-red.png'
                                            }
                                            alt=""
                                          />
                                        </div>
                                      ) : (
                                        ''
                                      )}
                                      <span className="tooltip-area-up-text">
                                        {result?.customer_name}
                                        {result?.customer_name ? <br /> : ''}
                                        {result?.POS_Order}
                                        <br />
                                        {formatDate(result?.delivery_date)}
                                      </span>
                                    </div>
                                  </div>
                                </td>
                                <td>{result?.po_QTY ? result?.po_QTY : ''}</td>
                                <td> {result?.price ? toFormatPrice(result?.price, { addSymbol: true },result?.currency) : ''}</td>
                                <td className="text-end">
                                  {result?.aging ? result?.aging : '0'}
                                </td>
                                <td
                                  className="location-td"
                                  data-location={
                                    result?.location_name
                                      ? result?.location_name
                                      : ''
                                  }
                                >
                                  <span className="link-color">
                                    {' '}
                                    {result?.location_name
                                      ? result?.location_name
                                      : ''}{' '}
                                  </span>{' '}
                                  <span className="text-center location-td-sub">
                                    {result?.warehouse_location_name
                                      ? result?.warehouse_location_name
                                      : ''}
                                  </span>
                                </td>
                                <td>
                                  {result.status_type === 'stock' ? (
                                    <div className="status-dot light-blue-bg  tooltip-area-up">
                                      <span className="tooltip-area-up-text">
                                        {t('Stock')}
                                      </span>
                                    </div>
                                  ) : result.status_type === 'transit' ? (
                                    <div className="status-dot green-bg  tooltip-area-up">
                                      <span className="tooltip-area-up-text">
                                        {t('Transit')}
                                      </span>
                                    </div>
                                  ) : result.status_type === 'warehouse' &&
                                    result.status_stock_id !==
                                    'custom_order' ? (
                                    <div className="status-dot status-gray-bg tooltip-area-up">
                                      <span className="tooltip-area-up-text">
                                        {t('Warehouse')}
                                      </span>
                                    </div>
                                  ) : result.status_type === 'reserve' ? (
                                    <div className="status-dot yellow-bg tooltip-area-up">
                                      <span className="tooltip-area-up-text">
                                        {t('Reserve')}
                                      </span>
                                    </div>
                                  ) : result.status_type === 'repair_order' ? (
                                    <div className="status-dot purple-bg tooltip-area-up">
                                      <span className="tooltip-area-up-text">
                                        {t('Repair Order')}
                                      </span>
                                    </div>
                                  ) : result.status_type === 'warehouse' &&
                                    result.status_stock_id ===
                                    'custom_order' ? (
                                    <div className="status-dot danger-bg tooltip-area-up">
                                      <span className="tooltip-area-up-text">
                                        {t('Custom Order')}
                                      </span>
                                    </div>
                                  ) : (
                                    <div className="status-dot danger-bg tooltip-area-up">
                                      <span className="tooltip-area-up-text">
                                        {t('Custom Order')}
                                      </span>
                                    </div>
                                  )}
                                </td>
                                <td className="text-danger">
                                  {result?.POS_Order ? result?.POS_Order : ''}
                                </td>
                                <td className="text-danger">
                                  {result?.customer_name
                                    ? result?.customer_name
                                    : ''}
                                </td>
                                <td className="text-danger">
                                  {result?.delivery_date
                                    ? formatDate(result?.delivery_date)
                                    : ''}
                                </td>
                                <td className="text-danger">
                                  {result?.due_days ? result?.due_days : ''}
                                </td>
                                <td>{result?.remark ? result?.remark : '-'}</td>
                                <td className="text-center">
                                  {result?.pos?.url ? (
                                    <a
                                      href={result?.pos?.url}
                                      target="_blank"
                                      rel="noreferrer"
                                    >
                                      <img
                                        className="pdf-image"
                                        src={
                                          base_url_assets +
                                          'images/icons/pdf-icon.png'
                                        }
                                        alt=""
                                      />
                                    </a>
                                  ) : (
                                    '-'
                                  )}
                                </td>
                              </tr>
                            )
                          })
                          : ''}
                      </tbody>
                      <tfoot>
                        <tr>
                          <td />
                          <td />
                          <td />
                          <td />
                          <td />
                          <td />
                          <td />
                          <td />
                          <td />
                          <td />
                          <td />
                          <td>
                            {transferinventorylist
                              ? transferinventorylist?.reduce(
                                (interation, val) =>
                                (interation =
                                  interation + parseInt(val.po_QTY)),
                                0,
                              )
                              : ''}
                          </td>
                          <td>
                            {/* {
                              toFormatPrice(transferinventorylist
                                ? transferinventorylist?.reduce(
                                  (interation, val) =>
                                  (interation =
                                    interation +
                                    toUnformatPrice(val?.price)),
                                  0
                                )
                                : "", { addSymbol: true })
                            } */}
                            {' '}
                          </td>
                          <td />
                          <td />
                          <td />
                          <td />
                          <td />
                          <td />
                          <td />
                          <td />
                        </tr>
                      </tfoot>
                    </table>
                    {datalodaer && <TableLoader />}

                  </>
                </div>
              </div>
              {transferinventorylist?.length > 0 ? (
                <Pagination
                  total={totalPages}
                  current={currentPage}
                  pagination={(crPage) => handlePaginations(crPage)}
                />
              ) : (
                ""
              )}
            </div>
            <Filtermodal
              submitfiltter={(current, filterLimit, filter) =>
                Gettransferinventory(current, filterLimit, filter, filtername)
              }
              limit={limit}
              custom_filter_enable={true}
            />
          </div>
        </div>
      </div>
      <Stockidmodal
        countstockid={countstockid}
      />
      <TableColumnModal
        tablehead={createtransferinventoryheadcheck}
        tblName={'tbl_inventory_Createstocktransfer'}
        calldatatable={Gettransferinventory}
      ></TableColumnModal>
      <Advancedfiltermodel></Advancedfiltermodel>
    </React.Fragment >
  )
}

export default CreateTransferInventory
